module.exports = __webpack_public_path__ + "static/img/dsh.2cfbcb6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dsh.svg
// module id = +iw8
// module chunks = 1 2